import { getHashValue } from './urlHelpers';

const TEN_MINUTES_IN_MILLISECONDS = 10 * 60 * 1000;

export const saveExpirableStringToLS = (data) => {
  const appURLStatus = {
    encodedAppPath: data,
    expiry: Date.now() + TEN_MINUTES_IN_MILLISECONDS,
  };

  localStorage.setItem('appURLPath', JSON.stringify(appURLStatus));
};

export const getAppURLFromLocalStorage = () => {
  try {
    const appURLDataString = localStorage.getItem('appURLPath');
    const appURLData = JSON.parse(appURLDataString);
    const now = Date.now();
    const encodedAppPath = now <= appURLData.expiry ? appURLData.encodedAppPath : '';
    const urlHash = getHashValue(window.location.hash, 'state');

    /*
      Auth0 best practice: Only allow the user to proceed if the `#state` hash value from their
      callback URL is the same as our locally stored version.
    */
    if (unescape(urlHash) === encodedAppPath) {
      return window.atob(encodedAppPath);
    }
    return '';
  } catch (e) {
    return '';
  }
};
